import { render } from "./home.vue?vue&type=template&id=e7f10b1e&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=e7f10b1e&scoped=true&lang=css"

import exportComponent from "/Users/nekomini/.gitlab-runner/builds/pUzgx6Vs/0/neko_client_projects/shojo-landing-page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7f10b1e"]])

export default __exports__